"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Tabs = _interopRequireDefault(require("@insided/deprecated-preact-components/Tabs"));

var _LeaderboardUserList = _interopRequireDefault(require("./LeaderboardUserList"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var tabs = ['thisWeek', 'allTime'];

var PointsLeaderboard = function PointsLeaderboard(props) {
  tabs = props.visibleTabs ? props.visibleTabs : tabs;
  var tabTitles = tabs.map(function (tab) {
    return (0, _preact.h)(_phrase.default, {
      key: tab,
      p: "leaderboard.points.".concat(tab)
    });
  });
  return (0, _preact.h)("div", {
    className: "leaderboard-container"
  }, (0, _preact.h)(_Tabs.default, {
    titles: tabTitles
  }, tabs.map(function (tab) {
    return (0, _preact.h)(_LeaderboardUserList.default, {
      key: tab,
      tabTitle: tab,
      maxResults: props.maxResults,
      excludeUserRole: props.excludeUserRole ? props.excludeUserRole : [],
      emptyMessage: props.emptyMessage,
      showLink: props.showLink,
      linkText: props.linkText,
      showLoggedInUserSection: props.showLoggedInUserSection
    });
  })));
};

var _default = PointsLeaderboard;
exports.default = _default;